import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'

// 发布开放许可信息
export function issueInfo(data) {
  return request({
    url: '/bus/open',
    method: 'POST',
    data
  })
}

// 获取总数
export function getCounts() {
  return request({
    url: '/bus/open/counts',
    method: 'GET',
  })
}

// 获取开放许可信息详情
export function getLicenceDetail(id) {
  return request({
    url: `/bus/open/${id}`,
    method: 'GET',
  })
}

export function editLience(data) {
  return request({
    url: `/bus/open`,
    method: 'PUT',
    data
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/system/user/getUserInfo',
    method: 'GET',
  })
}

// 获取开放许可信息
export function getInfo(param) {
  const url = handlerGetUrlParams('/bus/open/list', param)
  return request({
    url,
    method: 'GET'
  })
}

// 删除开放许可信息
export function deleteInfo(id) {
  return request({
    url: `/bus/open/del/${id}`,
    method: 'DELETE'
  })
}

// 审批开放许可信息
export function statusInfo(data) {
  return request({
    url: '/bus/contents/open/audit',
    method: 'PUT',
    data
  })
}

// 编辑开放许可信息
export function editInfo(data) {
  return request({
    url: '/bus/operation',
    method: 'PUT',
    data
  })
}

// 发布和下架开放许可信息
export function editStatusInfo(data) {
  return request({
    url: '/bus/open/status',
    method: 'PUT',
    data
  })
}